import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { capitalize, sortBy } from 'lodash';
import { GoodsInTransitKey, businessInsuranceKey, hiredInPlantKey } from '../localeConstants';
import { InsuranceType, LandingPageThemeEnum, OverrideActionStatus, PolicyDocumentType, ProductSchemeEnum, QuoteBillPaymentStatusEnum, QuoteStatus } from '../shared/generated';
import { getLocalTranslation } from '../utils/i18nKit';
export var maxInputEmployeeNumber = 9999;
export var QuoteProcessTypeEnum = {
  Normal: 2,
  OldGitUS: 3
}; // EU list

export var EuropeanUnionList = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE']; // EU Hiscox list

export var EuropeanUnionHiscoxList = []; // Chubb list

export var ChubbCountryList = ['GB'];
export var UKCountryList = ['GB', 'IM', 'GI', 'GG', 'JE'];
export var onlyUKCountryList = ['GB']; // American list

export var AmericanCountryList = ['US']; // All Allow country list

export var AllAllowCountryList = _toConsumableArray(new Set([].concat(EuropeanUnionList, EuropeanUnionHiscoxList, UKCountryList, AmericanCountryList))); // provider code: chubb broker

export var PROVIDER_SOURCE = function PROVIDER_SOURCE() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return {
    CHUBB: {
      value: 'CHUBB_UK',
      label: 'Chubb Limited',
      lowerLabel: $t('common:chubb'),
      order: 1,
      displayName: 'Chubb Limited'
    },
    HISCOX: {
      value: 'HISCOX',
      label: 'Hiscox Limited',
      lowerLabel: $t('common:hiscox'),
      order: 2,
      displayName: 'Hiscox Limited'
    },
    HISCOX_US: {
      value: 'HISCOX_US',
      label: 'Hiscox USA',
      lowerLabel: $t('common:hiscox_us'),
      order: 2,
      displayName: 'Hiscox USA'
    },
    MSAMLIN: {
      value: 'MS_AMLIN',
      label: 'MS Amlin Limited',
      lowerLabel: $t('common:MS_amlin'),
      order: 3,
      displayName: 'MS Amlin Limited'
    },
    ACCELERANT: {
      value: 'ACCELERANT',
      label: 'Accelerant Insurance Limited',
      lowerLabel: $t('common:accelerant'),
      order: 4,
      displayName: 'Accelerant Insurance Limited'
    },
    SAGIC: {
      value: 'SAGIC_UK',
      label: 'SAGIC_UK',
      lowerLabel: $t('common:sagic'),
      order: 4,
      displayName: 'SAGIC'
    },
    // BROKER: {
    //   value: 'Broker',
    //   label: 'Broker',
    //   lowerLabel: $t('common:broker'),
    //   order: 110,
    //   displayName: 'Broker',
    // },
    GREATEAMERICAN: {
      value: 'GREAT_AMERICAN',
      label: 'Great American Insurance Group',
      lowerLabel: $t('common:great_american'),
      order: 6,
      displayName: 'Great American Insurance Group'
    },
    ACCELERANT_GIT: {
      value: 'ACCELERANT_GIT',
      label: 'Accelerant Insurance Limited (GIT)',
      lowerLabel: $t('common:goods_in_transit'),
      order: 12,
      displayName: 'Accelerant Insurance GIT Limited'
    },
    RECRUITMENT: {
      value: 'ACCELERANT_RECRUITMENT',
      label: 'Accelerant Insurance Recruitment Limited',
      lowerLabel: 'Recruitment',
      order: 13,
      displayName: 'Accelerant Insurance Recruitment Limited'
    },
    GREATEAMERICAN_BUSINESS_INSURANCE: {
      value: 'GREAT_AMERICAN_BUSINESS',
      label: 'Great American Business Insurance',
      lowerLabel: 'Great American Business Insurance',
      order: 7,
      displayName: 'Great American Business Insurance'
    }
  };
};
export var PROVIDER_SOURCE_LIST = function PROVIDER_SOURCE_LIST() {
  return Object.values(PROVIDER_SOURCE());
};
export var getRealDisplayProviderSourceList = function getRealDisplayProviderSourceList() {
  return PROVIDER_SOURCE_LIST().filter(function (item) {
    return !['HISCOX', 'MS_AMLIN', 'SAGIC_UK'].includes(item.value);
  });
};
/**
 * business activities
 */

export var chubbBusinessActivitiesList = [{
  value: 'IT-020',
  label: 'IT Software Engineer/Developer'
}, {
  value: 'MKT-013',
  label: 'Web Marketing Services'
}, {
  value: 'IT-019',
  label: 'IT Software Consultant'
}, {
  value: 'BCS-025',
  label: 'Business Consultant'
}];
/**
 * income
 */

export var chubbEstimatedIncomeList = [{
  value: 'BAND_0000K_0100K',
  label: 'Under £100k'
}, {
  value: 'BAND_0100K_0150K',
  label: 'Up to £150k'
}, {
  value: 'BAND_0150K_0200K',
  label: 'Up to £200k'
}, {
  value: 'BAND_0200K_0300K',
  label: 'Up to £300k'
}, {
  value: 'BAND_0300K_0400K',
  label: 'Up to £400k'
}, {
  value: 'BAND_0400K_0500K',
  label: 'Up to £500k'
}, {
  value: 'BAND_0500K_0750K',
  label: 'Up to £750k'
}, {
  value: 'BAND_0750K_1000K',
  label: 'Up to £1m'
}, {
  value: 'BAND_1000K_1500K',
  label: 'Up to £1.5m'
}, {
  value: 'BAND_1500K_2000K',
  label: 'Over £1.5m'
}];
/**
 * Questions
 */

export var declarationsOptionsMap = {
  '1': [{
    label: 'I disagree',
    value: 'I disagree',
    truelyValue: false,
    capitalLabel: 'I DISAGREE',
    yesOrNoCapitalLabel: 'NO',
    yesOrNoLowerCaseLabel: 'no'
  }, {
    label: 'I agree',
    value: 'I agree',
    truelyValue: true,
    capitalLabel: 'I AGREE',
    yesOrNoCapitalLabel: 'YES',
    yesOrNoLowerCaseLabel: 'yes'
  }],
  '2': [{
    label: 'No',
    value: 'No',
    truelyValue: false,
    capitalLabel: 'NO',
    yesOrNoCapitalLabel: 'NO',
    yesOrNoLowerCaseLabel: 'no'
  }, {
    label: 'Yes',
    value: 'Yes',
    truelyValue: true,
    capitalLabel: 'YES',
    yesOrNoCapitalLabel: 'YES',
    yesOrNoLowerCaseLabel: 'yes'
  }]
}; // GidInsuranceBundle

export var GidInsuranceBundleAll = 'all';
export var GidInsuranceBundleListOnly = 'only_git';
export var GidInsuranceBundleList = [{
  value: GidInsuranceBundleAll,
  label: 'Goods in transit + liability bundle',
  money: 110.88
}, {
  value: GidInsuranceBundleListOnly,
  label: 'Goods in transit only',
  icon: '',
  money: 56.04
}];
/**
 * Income split
 */

export var incomeSplitCountriesMap = function incomeSplitCountriesMap() {
  var _getLocalTranslation2 = getLocalTranslation(),
      $t = _getLocalTranslation2.$t;

  return {
    UK: {
      value: 'UK',
      label: $t('kit:country.UK')
    },
    EU: {
      value: 'EU',
      label: $t('kit:country.EU')
    },
    'US-CA': {
      value: 'US-CA',
      label: $t('kit:country.USA_and_canada')
    },
    'US-NA': {
      value: 'US-NA',
      // label: $t('kit:country.US_not_subject_to_US_law'),
      label: $t('kit:country.USA_and_canada'),
      desc: $t('kit:country.us_na_jurisdiction_desc'),
      tooltip: $t('kit:country.us_na_jurisdiction_tooltip')
    },
    USA: {
      value: 'USA',
      // label: $t('kit:country.USA'),
      label: $t('kit:country.USA_and_canada'),
      desc: $t('kit:country.usa_jurisdiction_desc'),
      tooltip: $t('kit:country.usa_jurisdiction_tooltip')
    },
    ROW: {
      value: 'ROW',
      label: $t('kit:country.rest_of_the_world')
    }
  };
};
export var incomeSplitCountries = function incomeSplitCountries() {
  return Object.values(incomeSplitCountriesMap());
};
export var ChubbSplitList = ['UK', 'EU', 'US-CA', 'ROW'];
export var CommonSplitList = ['UK', 'USA', 'ROW'];
export var getAccelerantSplitList = function getAccelerantSplitList() {
  return ['EU', 'UK', 'US-NA', 'USA', 'ROW'];
};
export var getAccelerantUKSplitList = function getAccelerantUKSplitList() {
  return ['UK', 'EU', 'US-NA', 'USA', 'ROW'];
};
/**
 * Broker
 */
// Broker - cover

export var BrokerCoverOptionList1 = [{
  value: 0,
  label: "I don't need this cover"
}, {
  value: 250000,
  label: '£250,000'
}, {
  value: 500000,
  label: '£500,000'
}, {
  value: 1000000,
  label: '£1,000,000'
}, {
  value: 3000000,
  label: '£3,000,000'
}, {
  value: 5000000,
  label: '£5,000,000'
}];
export var BrokerCoverOptionList2 = [{
  value: 0,
  label: "I don't need this cover"
}, {
  value: 50000,
  label: '£50,000'
}, {
  value: 100000,
  label: '£100,000'
}, {
  value: 250000,
  label: '£250,000'
}, {
  value: 500000,
  label: '£500,000'
}, {
  value: 1000000,
  label: '£1,000,000'
}, {
  value: 1500000,
  label: '£1,500,000'
}, {
  value: 2000000,
  label: '£2,000,000'
}];
export var BrokerCoverOptionList3 = [{
  value: 0,
  label: "I don't need this cover"
}, {
  value: 50000,
  label: '£50,000'
}];
export var ContractPeriodButtonList = [{
  value: 'rate',
  label: 'By rate'
}, {
  value: 'total',
  label: 'Total value'
}]; // Broker - questions

export var BusinessInterruptionIndemnityPeriodListMap = {
  12: {
    value: '12',
    label: '12 months'
  },
  24: {
    value: '24',
    label: '24 months'
  },
  36: {
    value: '36',
    label: '36 months'
  }
};
export var BusinessInterruptionIndemnityPeriodList = Object.values(BusinessInterruptionIndemnityPeriodListMap); // Chubb Contract: rate and total

export var ContractEstimatedIncomePerInfoMap = {
  perDay: {
    value: 'perDay',
    label: 'per day',
    maxCount: 7,
    minCount: 1,
    defaultCount: 5,
    unit: 'days',
    totalUnit: 'week'
  },
  perWeek: {
    value: 'perWeek',
    label: 'per week',
    maxCount: 4,
    minCount: 1,
    defaultCount: 4,
    unit: 'weeks',
    totalUnit: 'year'
  },
  perMonth: {
    value: 'perMonth',
    label: 'per month',
    maxCount: 9,
    minCount: 1,
    defaultCount: 3,
    unit: 'months',
    totalUnit: 'year'
  }
};
export var ContractEstimatedIncomePerInfoList = Object.values(ContractEstimatedIncomePerInfoMap); // Questions

export var MsAmlinSectorsOptionsList = function MsAmlinSectorsOptionsList() {
  var _getLocalTranslation3 = getLocalTranslation(),
      $t = _getLocalTranslation3.$t;

  return [{
    value: 'Rail',
    label: $t('kit:rail')
  }, {
    value: 'Aviation',
    label: $t('kit:aviation')
  }, {
    value: 'Nuclear',
    label: $t('kit:nuclear')
  }, {
    value: 'Offshore',
    label: $t('kit:offshore')
  }, {
    value: 'none',
    label: $t('kit:none_of_the_above')
  }];
};
/**
 * Purchase probability
 */

export var QUOTE_PURCHASE_PROBABILITY_MAP = function QUOTE_PURCHASE_PROBABILITY_MAP() {
  var _getLocalTranslation4 = getLocalTranslation(),
      $t = _getLocalTranslation4.$t;

  return {
    high: {
      value: 'high',
      label: $t('common:high')
    },
    medium: {
      value: 'medium',
      label: $t('common:medium')
    },
    low: {
      value: 'low',
      label: $t('common:low')
    },
    not_interested: {
      value: 'not_interested',
      label: $t('common:not_interested')
    }
  };
};
export var QUOTE_PURCHASE_PROBABILITY_LIST = function QUOTE_PURCHASE_PROBABILITY_LIST() {
  return Object.values(QUOTE_PURCHASE_PROBABILITY_MAP());
};
/**
 * Payment schedule status
 */

export var getPaymentScheduleStatusMap = function getPaymentScheduleStatusMap() {
  var _getLocalTranslation5 = getLocalTranslation(),
      $t = _getLocalTranslation5.$t;

  return {
    pending: {
      value: QuoteBillPaymentStatusEnum.PENDING,
      label: $t('kit:pending')
    },
    succeeded: {
      value: QuoteBillPaymentStatusEnum.SUCCEEDED,
      label: $t('kit:success')
    },
    failed: {
      value: QuoteBillPaymentStatusEnum.FAILED,
      label: $t('kit:fail')
    },
    canceled: {
      value: QuoteBillPaymentStatusEnum.CANCELED,
      label: $t('kit:quotes.cancelled')
    },
    no_need_pay: {
      value: QuoteBillPaymentStatusEnum.NO_NEED_PAY,
      label: 'No need to pay'
    }
  };
};
export var getPaymentScheduleStatusList = function getPaymentScheduleStatusList() {
  return Object.values(getPaymentScheduleStatusMap());
};
/**
 * Referral status
 */

export var getReferralStatusMap = function getReferralStatusMap() {
  var _getLocalTranslation6 = getLocalTranslation(),
      $t = _getLocalTranslation6.$t;

  return {
    approved: {
      value: 'approved',
      label: $t('kit:approved')
    },
    declined: {
      value: 'declined',
      label: $t('kit:declined')
    },
    pending: {
      value: 'pending',
      label: $t('kit:pending')
    }
  };
};
export var getReferralStatusList = function getReferralStatusList() {
  return Object.values(getReferralStatusMap());
};
/**
 * Quote file type
 */

export var QUOTE_SIGNATURE_FILE_TYPE_MAP = function QUOTE_SIGNATURE_FILE_TYPE_MAP() {
  var _getLocalTranslation7 = getLocalTranslation(),
      $t = _getLocalTranslation7.$t;

  return {
    details: {
      value: 'details',
      label: $t('common:details_document')
    },
    quote: {
      value: 'quote',
      label: $t('common:quote_document')
    },
    typeform: {
      value: 'typeform',
      label: $t('common:typeform_document')
    },
    signed: {
      value: 'signed',
      label: $t('common:signed')
    },
    sch: {
      value: PolicyDocumentType.SCH,
      label: $t('common:schedule')
    },
    ipd: {
      value: PolicyDocumentType.IPD,
      label: $t('common:insurance_policy_document')
    },
    cer: {
      value: PolicyDocumentType.CER,
      label: $t('common:certificate_of_insurance')
    },
    lossReport: {
      value: 'loss_report',
      label: $t('common:loss_report_document')
    },
    claimSupplement: {
      value: 'claim_supplement',
      label: 'Claim Supplement'
    },
    purchaseMergerSupplement: {
      value: 'purchase_merger_supplement',
      label: 'Purchase or Merger Supplement'
    }
  };
};
/*
 * Business insurance
 */

export var BUSINESS_INSURANCE_TYPE_MAP = {
  businessInsurance: {
    value: 'business-insurance',
    label: 'Business insurance',
    desc: 'Our business insurance includes professional indemnity, public liability, employers liability, and other business covers.'
  },
  hiredInPlant: {
    value: 'construction-insurance',
    label: 'Construction insurance',
    desc: 'Our construction insurance include hired in plant, owned plant and construction all risk insurances.'
  },
  goodsInTransit: {
    value: 'goods-in-transit-insurance',
    label: 'Goods in transit insurance',
    desc: 'Goods in transit (GIT) insurance is a type of insurance that protects your goods while they are being transported from one location to another. It covers the items in case there is theft, loss or damage during transportation.'
  }
};
export var BUSINESS_INSURANCE_TYPE_LIST = Object.values(BUSINESS_INSURANCE_TYPE_MAP);
/**
 * Quote list page
 */

export var QuoteTagEnum = function QuoteTagEnum() {
  var _getLocalTranslation8 = getLocalTranslation(),
      $t = _getLocalTranslation8.$t;

  return {
    ApiFail: {
      value: 'api_fails',
      label: $t('kit:quoteTag.apiFail')
    },
    Signed: {
      value: 'is_signed',
      label: $t('kit:quoteTag.signed')
    },
    ReachedPayment: {
      value: 'reached_payment',
      label: $t('kit:quoteTag.reachedPayment')
    },
    isViewed: {
      value: 'is_viewed',
      label: $t('kit:quoteTag.isViewed')
    },
    docSent: {
      value: 'doc_sent',
      label: $t('kit:quoteTag.docSent')
    },
    docNotSent: {
      value: 'doc_not_sent',
      label: $t('kit:quoteTag.docNotSent')
    },
    referralApproved: {
      value: 'referral_approved',
      label: $t('kit:quoteTag.referralApproved')
    },
    purchasedWithoutDOTNumber: {
      value: 'have_no_dot_number',
      label: $t('kit:quoteTag.purchasedWithoutDOTNumber')
    },
    renewalPaymentFailed: {
      value: 'renewal_payment_failed',
      label: $t('kit:quoteTag.renewalPaymentFailed')
    },
    missingVIN: {
      value: 'missing_vin',
      label: $t('kit:quoteTag.missingVIN')
    },
    missingVINCollected: {
      value: 'vin_collected',
      label: $t('kit:quoteTag.missingVINCollected')
    },
    missingLossReport: {
      value: 'missing_loss_report',
      label: $t('kit:quoteTag.missingLossReport')
    },
    missingLossReportCollected: {
      value: 'loss_report_collected',
      label: $t('kit:quoteTag.missingLossReportCollected')
    },
    providerChange: {
      value: 'provider_change',
      label: $t('kit:quoteTag.providerChange')
    },
    partiallyQuoted: {
      value: 'partially_quoted',
      label: $t('kit:quoteTag.partiallyQuoted')
    },
    switchToJove: {
      value: 'switch_to_jove_filter',
      label: $t('kit:quoteTag.switchToJove')
    }
  };
};
export var QuoteTagStatusList = function QuoteTagStatusList() {
  return Object.values(QuoteTagEnum());
};
export var QuoteCountTagEnum = function QuoteCountTagEnum() {
  var _getLocalTranslation9 = getLocalTranslation(),
      $t = _getLocalTranslation9.$t;

  return {
    quoteViewed: {
      value: 'quote_viewed',
      label: $t('kit:quote_viewed')
    },
    emailViewed: {
      value: 'email_viewed',
      label: $t('kit:email_viewed')
    }
  };
};
export var QuoteCountTagStatusList = function QuoteCountTagStatusList() {
  return Object.values(QuoteCountTagEnum());
};
/**
 * Region
 */

export var FilterRegionMap = function FilterRegionMap() {
  var _getLocalTranslation10 = getLocalTranslation(),
      $t = _getLocalTranslation10.$t;

  return {
    UK: {
      value: 'GB',
      label: $t('kit:united_kingdom')
    },
    US: {
      value: 'US',
      label: $t('kit:united_states')
    },
    EU: {
      value: 'EU',
      label: $t('kit:european_union')
    }
  };
};
export var FilterRegionList = function FilterRegionList() {
  return Object.values(FilterRegionMap());
};
export var getQuoteStatusMap = function getQuoteStatusMap() {
  var _objectSpread2;

  var _getLocalTranslation11 = getLocalTranslation(),
      $t = _getLocalTranslation11.$t;

  var serverStatusMap = {};
  var list = [];
  Object.keys(QuoteStatus).forEach(function (key) {
    var _QuoteStatus$key;

    list.push({
      value: QuoteStatus[key],
      label: capitalize((_QuoteStatus$key = QuoteStatus[key]) === null || _QuoteStatus$key === void 0 ? void 0 : _QuoteStatus$key.replaceAll('_', ' '))
    });
  });
  list = sortBy(list, 'label');
  list.forEach(function (item) {
    serverStatusMap[item.value] = item;
  });
  return _objectSpread(_objectSpread({}, serverStatusMap), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, QuoteStatus.NOT_STARTED, {
    value: QuoteStatus.NOT_STARTED,
    label: $t('kit:quotes.not_started')
  }), _defineProperty(_objectSpread2, QuoteStatus.QUOTE_START, {
    value: QuoteStatus.QUOTE_START,
    label: $t('kit:quotes.quote_start')
  }), _defineProperty(_objectSpread2, QuoteStatus.QUOTED, {
    value: QuoteStatus.QUOTED,
    label: $t('kit:quotes.quoted')
  }), _defineProperty(_objectSpread2, QuoteStatus.IN_PROGRESS, {
    value: QuoteStatus.IN_PROGRESS,
    label: $t('kit:quotes.in_progress')
  }), _defineProperty(_objectSpread2, QuoteStatus.DROPOUT_BEFORE_QUOTE, {
    value: QuoteStatus.DROPOUT_BEFORE_QUOTE,
    label: $t('kit:quotes.dropout_before_quote')
  }), _defineProperty(_objectSpread2, QuoteStatus.DROPOUT_BEFORE_PURCHASE, {
    value: QuoteStatus.DROPOUT_BEFORE_PURCHASE,
    label: $t('kit:quotes.dropout_before_purchase')
  }), _defineProperty(_objectSpread2, QuoteStatus.REFERRAL, {
    value: QuoteStatus.REFERRAL,
    label: $t('kit:quotes.referral')
  }), _defineProperty(_objectSpread2, QuoteStatus.BROKER, {
    value: QuoteStatus.BROKER,
    label: $t('kit:broker')
  }), _defineProperty(_objectSpread2, QuoteStatus.PURCHASED_NOT_SIGNED, {
    value: QuoteStatus.PURCHASED_NOT_SIGNED,
    label: $t('kit:quotes.purchased_not_signed')
  }), _defineProperty(_objectSpread2, QuoteStatus.PRE_PAYMENT, {
    value: QuoteStatus.PRE_PAYMENT,
    label: $t('kit:quotes.pre_payment')
  }), _defineProperty(_objectSpread2, QuoteStatus.PAYMENT_PENDING, {
    value: QuoteStatus.PAYMENT_PENDING,
    label: $t('kit:quotes.payment_pending')
  }), _defineProperty(_objectSpread2, QuoteStatus.DROPOUT_BEFORE_SIGNING, {
    value: QuoteStatus.DROPOUT_BEFORE_SIGNING,
    label: $t('kit:quotes.dropout_before_signing')
  }), _defineProperty(_objectSpread2, QuoteStatus.DROPOUT_AFTER_SIGNING, {
    value: QuoteStatus.DROPOUT_AFTER_SIGNING,
    label: $t('kit:quotes.dropout_after_signing')
  }), _defineProperty(_objectSpread2, QuoteStatus.SUBSCRIPTION_PAYMENT_FAILED, {
    value: QuoteStatus.SUBSCRIPTION_PAYMENT_FAILED,
    label: $t('kit:quotes.subscription_payment_failed')
  }), _defineProperty(_objectSpread2, QuoteStatus.PURCHASED, {
    value: QuoteStatus.PURCHASED,
    label: $t('kit:quotes.purchased')
  }), _defineProperty(_objectSpread2, QuoteStatus.PURCHASE_FAILED, {
    value: QuoteStatus.PURCHASE_FAILED,
    label: $t('kit:quotes.purchase_failed')
  }), _defineProperty(_objectSpread2, QuoteStatus.CANCELLED, {
    value: QuoteStatus.CANCELLED,
    label: $t('kit:quotes.cancelled')
  }), _defineProperty(_objectSpread2, QuoteStatus.NOT_INTERESTED, {
    value: QuoteStatus.NOT_INTERESTED,
    label: $t('kit:quotes.not_interested')
  }), _defineProperty(_objectSpread2, QuoteStatus.SUCCESS, {
    value: QuoteStatus.SUCCESS,
    label: $t('kit:success')
  }), _defineProperty(_objectSpread2, QuoteStatus.FAIL, {
    value: QuoteStatus.FAIL,
    label: $t('kit:fail')
  }), _objectSpread2));
};
export var getQuoteStatusList = function getQuoteStatusList() {
  return Object.values(getQuoteStatusMap());
};
export var getRealDisplayQuoteStatusList = function getRealDisplayQuoteStatusList() {
  return getQuoteStatusList().filter(function (item) {
    return ![QuoteStatus.SUCCESS, QuoteStatus.FAIL, QuoteStatus.IN_PROGRESS, QuoteStatus.UNKNOWN, QuoteStatus.QUOTED_CONFIRMING, QuoteStatus.PAYMENT_PROCESSING, QuoteStatus.DUPLICATED, QuoteStatus.POST_PURCHASE_LOGIN_CUSTOMER].includes(item.value);
  });
};
export var getQuotePremiumOverrideStatusMap = function getQuotePremiumOverrideStatusMap() {
  var _ref;

  var _getLocalTranslation12 = getLocalTranslation(),
      $t = _getLocalTranslation12.$t;

  return _ref = {}, _defineProperty(_ref, OverrideActionStatus.APPROVED, {
    value: OverrideActionStatus.APPROVED,
    label: $t('kit:approved')
  }), _defineProperty(_ref, OverrideActionStatus.PENDING, {
    value: OverrideActionStatus.PENDING,
    label: $t('kit:pending')
  }), _defineProperty(_ref, OverrideActionStatus.REJECTED, {
    value: OverrideActionStatus.REJECTED,
    label: $t('kit:rejected')
  }), _ref;
};
export var getQuotePremiumOverrideStatusList = function getQuotePremiumOverrideStatusList() {
  return Object.values(getQuotePremiumOverrideStatusMap());
};
export var getContractorProviderInsurerMap = function getContractorProviderInsurerMap() {
  return {
    accelerant: {
      value: PROVIDER_SOURCE().ACCELERANT.value,
      label: PROVIDER_SOURCE().ACCELERANT.label
    },
    greatAmerican: {
      value: PROVIDER_SOURCE().GREATEAMERICAN.value,
      label: PROVIDER_SOURCE().GREATEAMERICAN.label
    }
  };
};
export var getContractorProviderInsurerList = function getContractorProviderInsurerList() {
  return Object.values(getContractorProviderInsurerMap());
};
export var getBusinessInsuranceLandingPageThemeMap = function getBusinessInsuranceLandingPageThemeMap() {
  return {
    sme: {
      value: LandingPageThemeEnum.CONTRACTOR_SME,
      label: 'Contractor & SME'
    },
    commercial: {
      value: LandingPageThemeEnum.COMMERCIAL_BUSINESS,
      label: 'Commercial Business'
    },
    recruitment: {
      value: LandingPageThemeEnum.RECRUITMENT_PAYROLL,
      label: 'Recruitment & Payroll'
    }
  };
};
export var getBusinessInsuranceLandingPageThemeList = function getBusinessInsuranceLandingPageThemeList() {
  return Object.values(getBusinessInsuranceLandingPageThemeMap());
};
export var getBusinessInsuranceProductSchemeMap = function getBusinessInsuranceProductSchemeMap() {
  return {
    accelerant: {
      value: ProductSchemeEnum.ACCELERANT,
      label: 'Commercial Combined'
    },
    // recruitment: {
    //   value: PROVIDER_SOURCE().RECRUITMENT.value,
    //   label: 'Recruitment & Umbrella',
    // },
    r2r: {
      value: ProductSchemeEnum.RENT_TO_RENT,
      label: 'Rent-to-Rent'
    },
    uces: {
      value: ProductSchemeEnum.UCES,
      label: 'UCES (Universal Credit Eco System)'
    }
  };
};
export var getBusinessInsuranceProductSchemeMapList = function getBusinessInsuranceProductSchemeMapList() {
  return Object.values(getBusinessInsuranceProductSchemeMap());
};
export var getQuoteInsuranceTypeCovertToServerTypeMap = function getQuoteInsuranceTypeCovertToServerTypeMap() {
  var _ref2;

  return _ref2 = {}, _defineProperty(_ref2, GoodsInTransitKey, InsuranceType.GOODS_IN_TRANSIT_INSURANCE), _defineProperty(_ref2, businessInsuranceKey, InsuranceType.BUSINESS_INSURANCE), _defineProperty(_ref2, hiredInPlantKey, InsuranceType.CONSTRUCTION_INSURANCE), _ref2;
};
export var getQuoteInsuranceTypeCovertToLocalTypeMap = function getQuoteInsuranceTypeCovertToLocalTypeMap() {
  var _ref3;

  return _ref3 = {}, _defineProperty(_ref3, InsuranceType.GOODS_IN_TRANSIT_INSURANCE, GoodsInTransitKey), _defineProperty(_ref3, InsuranceType.BUSINESS_INSURANCE, businessInsuranceKey), _defineProperty(_ref3, InsuranceType.CONSTRUCTION_INSURANCE, hiredInPlantKey), _ref3;
};